import { memo, useCallback, type JSX } from 'react';

import styled from '@mint-lib/styled';

type Props<T> = {
  onChange: (value: T) => void;
  isActive: boolean;
  children: JSX.Element;
  value: T;
};

function TabContainer<T>({ children, value, onChange, isActive }: Props<T>) {
  const handleChange = useCallback(() => {
    onChange(value);
  }, [onChange, value]);

  return (
    <TabWrapperStyled onClick={handleChange} $isActive={isActive}>
      {children}
    </TabWrapperStyled>
  );
}

const TabWrapperStyled = styled('div')<{ $isActive: boolean }>`
  border-radius: 6px;
  background-color: ${({ theme }) => theme.palette.ui.primary};
  border: ${({ theme, $isActive }) =>
    $isActive ? `1px solid ${theme.palette.action.focusBorder}` : 'none'};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.palette.ui.secondary};
  }
`;

export default memo(TabContainer) as typeof TabContainer;
